import React from 'react'
import Hero from '../component/gallary/Hero'
import PhotoGallery from './../component/gallary/PhotoGallery';

const Gallary = () => {
  return (
      <div>
      {/* <Hero /> */}
      <PhotoGallery />
    </div>
  )
}

export default Gallary

